import scrollToElement from "./ScrollElement";
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Grid } from "swiper/modules";

$(function () {
	$(".miss-pc-header-toggle").on("click", function () {
		$(".miss-pc-header-menu").slideToggle();
		$(this).find("span").toggleClass("fa-bars fa-xmark");
	});
	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$(".miss-pc-header").toggleClass("scrolling", scrollTop > 0);
	});

	$(".candidate-slider").each(function () {
		let $this = $(this);
		let $slider = $this.find(".swiper");
		let $prev = $this.find(".swiper-prev");
		let $next = $this.find(".swiper-next");
		let pagination = $this.find(".swiper-pagination");

		let missCandidateSlider = new Swiper($slider[0], {
			modules: [Navigation, Pagination, Grid],
			slidesPerView: 2.25,
			spaceBetween: 16,
			navigation: {
				nextEl: $next[0],
				prevEl: $prev[0],
			},
			pagination: {
				el: pagination[0],
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 4,
					spaceBetween: 70,
					grid: {
						rows: 2,
						fill: "row",
					},
				},
			},
		});
	});

	$(".candidate-tab").tabslet({
		container: "#candidateContainer",
	});

	let missPartnerSlider = new Swiper(".miss-partner-slider .swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 2.5,
		spaceBetween: 16,
		navigation: {
			nextEl: ".miss-partner-slider .swiper-next",
			prevEl: ".miss-partner-slider .swiper-prev",
		},
		loop: true,
		rewind: true,
		autoplay: {
			delay: 4000,
		},
		breakpoints: {
			576: {
				slidesPerView: 4.5,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 4.5,
				spaceBetween: 32,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 32,
			},
		},
	});

	if ($("body").hasClass("miss-phuong-chau-landing")) {
		AOS.init({
			easing: "ease-out-back",
			duration: 1000,
			// disable: "mobile",
		});
	}

	$(".anchor-link").on("click", function (e) {
		e.preventDefault();
		let target = $(this).attr("href");
		scrollToElement(target, 750, $(".miss-pc-header").outerHeight() + 20);
	});
});
